exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bubble[data-v-0558f0d6] {\n  width: 232px;\n  margin-bottom: 2px;\n}\n.bubble[data-v-0558f0d6]:last-child {\n    margin-bottom: 16px;\n    padding-bottom: 8px;\n}\n.bubble[data-v-0558f0d6]:first-child {\n    margin-top: 24px;\n}\n.preview[data-v-0558f0d6] {\n  display: inline-flex;\n  padding: 0 0 40px 102px;\n  align-items: center;\n  height: calc(100% - 96px);\n  width: 436px;\n  position: fixed;\n  z-index: 3;\n  right: 0;\n  top: 56px;\n  background-color: #fafafa;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.message-wrap[data-v-0558f0d6] {\n  max-height: 100%;\n}\n", ""]);

// exports
